import { get, isNil } from 'lodash-es';

import { ColorRuleProps, MatchValue } from '../../../core/types/color-rule.js';
import { singleLineName } from '../../../core/utils/single-line-name.js';
import type {
  XYChartSeriesWithDatapoints,
  ColorRuleValidator,
} from '../../types/xy-chart-internals.js';
import { getFallbackValueAccessor } from '../get-fallback-value-accessor.js';

export const hasSeriesMatchingDatapoint = (
  series: XYChartSeriesWithDatapoints,
  rule: ColorRuleProps,
  isValid: ColorRuleValidator,
): boolean => {
  const accessor = rule.valueAccessor ?? getFallbackValueAccessor(series);

  return series.data.some((datapoint) => {
    const rawSubject = get(datapoint, accessor);
    const subject = Array.isArray(rawSubject)
      ? singleLineName(rawSubject as string[])
      : (rawSubject as MatchValue);
    return (
      !isNil(subject) && isValid(subject, rule.comparator, rule.matchValue)
    );
  });
};
